function ConfirmationPaymentRequestNotificationModalCtrl($scope, $uibModalInstance, $timeout, deferred, paymentRequest, email, confirmationRequestService, alertService, sdkUtils) {
  $scope.paymentRequest = paymentRequest;
  $scope.emailForm = {
    email
  };
  $scope.saving = false;
  $scope.submitted = false;

  $scope.save = function(maintainLink, $event) {
    if ($event) $event.preventDefault();

    $scope.saving = true;

    $timeout(() => {
      deferred.resolve({
        maintainLink
      });
    }, 100);
  };

  $scope.sendEmail = function(form, $event) {
    if (!form) throw new Error('form');
    if ($event) $event.preventDefault();

    $scope.submitted = true;

    if (!form.$valid) return null;

    $scope.saving = true;

    return confirmationRequestService.performActionById($scope.paymentRequest.id, {
        type: 'SEND_CUSTOMER_INVITE',
        email: $scope.emailForm.email
      })
      .then(() => {
        deferred.resolve(true);
      })
      .catch(err => {
        $scope.saving = false;

        alertService.error(sdkUtils.getErrorFromResponse(err));
      });
  };

  $scope.close = function() {
    deferred.resolve(false);
  };
}

ConfirmationPaymentRequestNotificationModalCtrl.$inject = [
  '$scope',
  '$uibModalInstance',
  '$timeout',
  'deferred',
  'paymentRequest',
  'email',
  'jsSdk.confirmationRequest',
  'alertService',
  'jsSdk.utils'
];

export default ConfirmationPaymentRequestNotificationModalCtrl;



// WEBPACK FOOTER //
// ./src/modals/confirmationPaymentRequestNotification/controller.js